var nurseslounge_article = {
    init:function($params){
        $params = {user_id:libs.memoryGet('user_id')};
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_article.menu_selector(function(){
            nurseslounge_article.article($params);
        });
    },
    menu_selector:function(cback){
        $("footer").hide();
        libs.globalUrl();
        cback();
    },
    article:function($params){
        //Realtime Clock
        nurseslounge_article.article_date();
        nurseslounge_article.article_events();
    },
    article_date_binding:null,
    server_date_helper:null,
    server_date:null,
    set_server_date:function($serverDate){
        this.server_date_helper = new Date();
        this.server_date = new Date($serverDate);
    },
    get_server_date:function(){
        var $now  = new Date().getTime();
        var $diff = $now - this.server_date_helper.getTime();
        var $date = this.server_date.getTime() + $diff;
        return new Date($date);
    },
    article_date:function(cback){
        var $artcileDate = libs.memoryGet('article_date');
        if($artcileDate){
            try{
                $artcileDate.abort();
            }catch($e){

            }
        }
        $artcileDate = $.ajax({
            url:location.href,
            method: "GET",
            cache:false,
            dataType: "html",
            success: function ($data, $status, $response) {
                var $dateString = $response.getResponseHeader('date');
                if ($dateString.indexOf('GMT')) {
                    $dateString = $dateString.replace('GMT','');
                }
                nurseslounge_article.set_server_date($dateString);
                nurseslounge_article.article_date_html();
                if(cback != undefined){
                    cback();
                }
            }
        });
        libs.memorySave('article_date', $artcileDate);
    },
    article_date_html:function(){
        var $refreshEverySeconds = 1;
        var $now = nurseslounge_article.get_server_date().getTime();
        var $article = $("#nurseslounge-article");
        var $ele = $article.find(".article-wrapper:first .date:first");
        if($ele.length > 0){
            var $val = $ele.data('articledate');
            var $newDate = $val.split(' ');
            var $yearMonthDay = $newDate[0];
            $yearMonthDay = $yearMonthDay.split('-');
            var $HourMinuteSecond = $newDate[1];
            $HourMinuteSecond = $HourMinuteSecond.split(':');
            var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
            var $second = $date.getSeconds();
            $second = $second <= 9 ? '0' + $second : $second;
            var $minute = $date.getMinutes();
            $minute = $minute <= 9 ? '0' + $minute : $minute;
            var $hour = $date.getHours();
            $hour = $hour <= 9 ? '0' + $hour : $hour;
            var $day = $date.getDate();
            $day = $day <= 9 ? '0' + $day : $day;
            var $month = $date.getMonth() + 1;
            $month = $month <= 9 ? '0' + $month : $month;
            var $year = $date.getFullYear();
            var $articleDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
            $date = $date.getTime();
            var $diffSeconds = Math.floor(($now - $date)/1000);
            var $diffMinutes = Math.floor($diffSeconds/60);
            var $diffHours = Math.floor($diffMinutes/60);
            var $diffDays = Math.floor($diffHours/24);
            var $chtml = '';
            if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
            }else
            if ($diffDays == 0 && $diffHours == 0){
                $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
            }else
            if ($diffDays == 0){
                $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
            }else
            if($diffDays < 4){
                $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
            }else{
                $date = $ele.data('articledate');
                $chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            }
            if($ele.html() != $chtml){
                $ele.data('articledate', $articleDate).html($chtml);
            }
        }
        try{
            clearTimeout(this.article_date_binding);
        }catch($e){}
        this.article_date_binding = setTimeout(function(){
            nurseslounge_article.article_date_html();
        }, ($refreshEverySeconds * 1000));
    },
    article_events:function(){
        var $article = $("#nurseslounge-article");
        var $articleActions = $article.find(".article-actions:first");
        var $articleWrapper = $article.find(".article-wrapper:first");
        var $key = $articleWrapper.data('key');
        var $params = $.extend({}, {key: $key}, {user_id:libs.memoryGet('user_id')});
        $articleActions.find('.option').unbind().click(function(){
           var $that = $(this);
           var $action = $that.data('action');
           var $url = $that.data('url');
           switch ($action) {
               case 'trash':{
                   nurseslounge_article.article_trash($params);
                   break;
               }
               case 'download':{
                   window.open($url, '_blank');
                   break;
               }
           }
        });
        $articleActions.find('.share-options:first .share-with').unbind().click(function(){
            var $that = $(this);
            var $action = $that.data('action');
            $params = $.extend({}, $params, {action:$action});
            nurseslounge_article.article_share($params);
        });
    },
    article_trash:function($params){
        nurseslounge_article.article_trash_request($params, function($data){
            var $articlePopUp = 'nurseslounge_myDashboard_wall_article_popup_' + $data.data.key;
            if($articlePopUp){
                var $nurseslounge = window.opener.$('#nurseslounge-lounge');
                if($nurseslounge.length > 0){
                    $nurseslounge.find('a[data-id="my_articles"]').click();
                }
                var $nursesloungeArticles = window.opener.$('#nurseslounge-articles');
                if($nursesloungeArticles.length > 0){
                    $nursesloungeArticles.find('.nurseslounge-articles-search input[name="search"]').keypress();
                }
                window.close($articlePopUp);
            }
        });
    },
    article_trash_request:function($params, cback){
        $.ajax({
            url: "/article/trash/"+$params.key,
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(cback != undefined){
                    cback($data);
                }
            }
        });
    },
    article_share:function($params){
        nurseslounge_article.article_share_request($params, function($data){
            var $document = $data.data.document;
            var $AF = $document.article_features;
            var $headline = $AF.headline && $AF.headline != '' ? $AF.headline: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
            var $imgOption1 = $AF && $AF.image && $AF.image.document_root ? $AF.image.document_root : null;
            var $imgOption2 = $document.document_thumb_root;
            var $imageThumb = $imgOption1 != null ? $imgOption1 : $imgOption2;
            var $shareLink = $document.share_link;
            $shareLink = encodeURIComponent($shareLink);
            var $url = encodeURIComponent(window.location.href);
            $imageThumb = encodeURIComponent($imageThumb);
            var $features = '';
            switch ($params.action) {
                case 'facebook':
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + $shareLink, '_blank', $features);
                    break;
                case 'twitter':
                    window.open('https://twitter.com/intent/tweet?url=' + $shareLink + '&text=' + $headline, '_blank', $features);
                    break;
                case 'pinterest':
                    window.open('http://www.pinterest.com/pin/create/button?url=' + $url + '&media=' + $imageThumb + '&description=' + $headline, '_blank', $features);
                    break;
                case 'linkedin':
                    window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + $shareLink, '_blank', $features);
                    break;
            }
        });
    },
    article_share_request:function($params, cback){
        $.ajax({
            url: "/article/share/"+$params.key,
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
};
